export class Klappen {
  produktTeil: string;
  language: string;
  records: KlappenRecords[];
}

export class KlappenRecords {
  produktTeilKnz: string;
  nutzenBreite: string;
  nutzenHoehe: string;
  formatBreite: string;
  rueckenBreite: string;
  anschnitt: string;
  ueberklebung2fR: string;
  ueberklebung4fR: string;
  klappenBreite: string;
  fondEinschlag: string;
  textAbstand: string;
  bezeichnung: string;
  produktTyp: string;
  klappen: string;
  endFormat: string;
  umfang: string;
  inhaltsPapier: string;
  bindeArt: string;
  umschlagPapier: string;
  umfangBildTeil: string;
  papierBildTeil: string;
  datum: string;
}

export class CalculatedKlappenRecord {
  nutzenBreite: number;
  nutzenHoehe: number;
  formatBreite: number;
  rueckenBreite: number;
  klappenBreite: number;
}
